import React from 'react';

const ForgotPassword = () => {
  return <div>ForgotPassword Page</div>;
};

export default ForgotPassword;
